import { useContext } from 'react';
import { UserAppContext } from './UserAppContext';

export const useUserAppContext = () => useContext(UserAppContext);
